import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {QuickDashboardMetric} from '../interfaces/quick-dashboard';
import {AdRequestOptions, AdRPeriodType, AdRReport} from '../interfaces/ad-reports';
import {Site} from '../interfaces/site';
import {Serializer} from '../interfaces/serializer';

@Injectable({
  providedIn: 'root'
})
export class QuickDashboardService {

  constructor(
    private _http: HttpClient
  ) {}

  public getMetric(dataSet: Serializer<Site>, slug: string, options: Partial<AdRequestOptions>, periods: Array<AdRPeriodType> = ['yesterday', 'last_7_days', 'this_month']): Observable<QuickDashboardMetric> {
    return this._http.post<QuickDashboardMetric>(`${environment.baseUrl}/api/${dataSet.id}/quick-dashboard/metric`, {
      parameters: {
        slug: slug,
        periods: periods,
      },
      options: options
    });
  }

  public getReport(dataSet: Serializer<Site>, slugs: Array<string> = ['ad-spend', 'ad-clicks', 'ad-conversions'], period: AdRPeriodType = 'this_month', options: Partial<AdRequestOptions>): Observable<AdRReport> {
    return this._http.post<AdRReport>(`${environment.baseUrl}/api/${dataSet.id}/quick-dashboard/report`, {
      parameters: {
        slugs: slugs,
        period: period
      },
      options: options
    });
  }

}
